import {
  UniFiCategoryId,
  UniFiChildCategorySlug,
} from "@ubnt/store.core/lib/constants/proStoreCategories/mapping/unifi";
import { SiteId } from "@ubnt/store.core/lib/contexts/MenuContext/mapping";
import image from "../../assets/physical-security/compact/g4-instant.png";
import { type Product } from "../../types";
import { physicalSecurityCompact } from "../product-list-groups/physicalSecurityCompact";
import { deployment } from "../properties/deployment";
import { outdoorReady } from "../properties/outdoorReady";

export const g4Instant: Product = {
  id: "g4Instant",
  productTitle: "G4 Instant",
  techspecsPath: [
    SiteId.TechSpecs,
    `/unifi/${UniFiCategoryId.CamerasNVRs}/uvc-g4-ins`,
  ],
  storePathParts: {
    productSlug: "uvc-g4-ins",
    category: UniFiChildCategorySlug.CamerasCompact,
  },
  sku: "UVC-G4-INS",
  description: "g4Instant.description",
  descriptionMaxWidth: 150,
  image: { src: image, width: 200, height: 140 },
  productListGroup: physicalSecurityCompact,
  propertyValues: [
    {
      propertyId: "dimensions",
      value: {
        type: "string",
        value: '81.6 x 50 x 47.2 mm\n(3.2 x 2 x 1.9")',
      },
    },
    {
      propertyId: "cameraResolution",
      value: { type: "string", value: "2K" },
    },
    {
      propertyId: "imageSensor",
      value: { type: "string", value: "5MP CMOS" },
    },
    {
      propertyId: "fieldOfView",
      value: {
        type: "translation",
        value: "g4Instant.fieldOfView",
      },
    },
    {
      propertyId: "nightVision",
      value: {
        type: "string",
        value: "6 m (20 ft)",
      },
    },
    {
      propertyId: "opticalZoom",
      value: {
        type: "boolean",
        value: false,
      },
    },
    {
      propertyId: "smartDetections",
      value: {
        type: "boolean",
        value: true,
      },
    },
    {
      propertyId: "faceRecognition",
      value: { type: "boolean", value: false },
    },
    {
      propertyId: "enhancedDetections",
      value: { type: "boolean", value: false },
    },
    {
      propertyId: "licensePlateRecognition",
      value: { type: "boolean", value: false },
    },
    {
      propertyId: "aiRecognition",
      value: { type: "boolean", value: false },
    },
    {
      propertyId: "cameraAudio",
      value: { type: "translation", value: "commons.cameraAudio.twoWayAudio" },
    },
    {
      propertyId: outdoorReady.id,
      value: {
        type: "string",
        value: "IPX5",
      },
    },
    {
      propertyId: "tamperResistance",
      value: { type: "string", value: "IK04" },
    },
    {
      propertyId: deployment.id,
      value: {
        type: "translation",
        value: "g4Instant.deployment",
      },
    },
  ],
};
